/* unplugin-vue-components disabled */import { render } from "./Account.vue?vue&type=template&id=06d9d733&scoped=true"
const script = {}

import "./Account.vue?vue&type=style&index=0&id=06d9d733&lang=scss&scoped=true"

import exportComponent from "D:\\phpstudy_pro\\WWW\\www.changshun.com\\web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06d9d733"]])

export default __exports__